import { useIntl } from 'react-intl';
import Switch from '@alltrails/denali/components/Switch';
import { fullName } from '@alltrails/shared/utils/formatters/textFormatters';
import Typography from '@alltrails/core/components/Typography';
import { ReportedUser } from '../../types';
import styles from './styles/styles.module.scss';

type BlockUserSectionProps = {
  reportUser: ReportedUser;
  blockActive: boolean;
  onBlockToggle: (blockActive: boolean) => void;
};

export default function BlockUserSection({ reportUser, blockActive, onBlockToggle }: BlockUserSectionProps) {
  const intl = useIntl();

  const userFullName = 'firstName' in reportUser ? fullName(reportUser) : reportUser.userName;
  return (
    <div className={styles.container}>
      <Typography component="div" variant="text200bold">
        {intl.formatMessage({ defaultMessage: 'Block {userFullName}' }, { userFullName })}
      </Typography>
      <Switch
        labelText={intl.formatMessage({
          defaultMessage: 'You’ll no longer see their reviews, photos, or posts. Neither of you will be able to see each other’s profiles.'
        })}
        selected={blockActive}
        testId="block-user-toggle"
        onChange={onBlockToggle}
        width="full"
      />
    </div>
  );
}
